import { createApi } from '../createApi';
import * as dummy from '../dummy/shopping';
import * as real from '../api/shopping';

const api = createApi(dummy, real);

/** 쇼핑 서비스 — API_DOCS: 10. 쇼핑 / 24. 관리자 - 쇼핑 */
export const shoppingService = {
  /* 서비스 (유저용) */
  getRetailProducts: api.getRetailProducts,
  getRetailCategories: api.getRetailCategories,
  getProducts: api.getShoppingProducts,
  getProductById: api.getShoppingProductById,
  getCart: api.getCart,
  addToCart: api.addToCart,
  updateCartItem: api.updateCartItem,
  deleteCartItem: api.deleteCartItem,
  createOrder: api.createOrder,
  getOrders: api.getOrders,
  getOrderById: api.getOrderById,
  requestRefund: api.requestShoppingRefund,

  /* 관리자 */
  adminGetProducts: api.getAdminProducts,
  adminCreateProduct: api.createAdminProduct,
  adminUpdateProduct: api.updateAdminProduct,
  adminDeleteProduct: api.deleteAdminProduct,
  adminGetOrders: api.getAdminOrders,
  adminUpdateOrderStatus: api.updateAdminOrderStatus,
  adminGetOrderDetail: api.getAdminOrderDetail,
  adminOperatorRefund: api.operatorRefund,
  adminGetRefundRequests: api.getRefundRequests,
  adminApproveRefund: api.approveRefundRequest,
  adminRejectRefund: api.rejectRefundRequest,
};
